import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#495A64" }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99935 2.99996L10.9993 4.99996M7.66602 12.3333H12.9993M2.33268 9.66663L1.66602 12.3333L4.33268 11.6666L12.0567 3.94263C12.3066 3.69259 12.4471 3.35351 12.4471 2.99996C12.4471 2.64641 12.3066 2.30733 12.0567 2.05729L11.942 1.94263C11.692 1.69267 11.3529 1.55225 10.9993 1.55225C10.6458 1.55225 10.3067 1.69267 10.0567 1.94263L2.33268 9.66663Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default memo(Icon);
